import { trackElementInteraction } from '../util/analytics'

up.compiler('.navigation', (element) => {

  function init() {
    let burger = element.querySelector('.navigation--burger')
    let links = element.querySelectorAll('a')

    burger.addEventListener('click', onBurgerClick)
    links.forEach((link) => {
      link.addEventListener('click', onLinkClick)
    })
  }

  function onBurgerClick(event) {
    trackElementInteraction(event.target.closest('.navigation--burger'), 'click.element')
    toggleNavigation()
    toggleBurgerIcon()
  }

  function onLinkClick(event) {
    event.preventDefault()
    trackElementInteraction(event.target.closest('a'), 'click.element')
    up.scroll('body', 0) // Scrolling looks bad if it is smooth
    up.follow(event.target)
  }

  function toggleBurgerIcon() {
    let icon = element.querySelector('.navigation--burger').querySelector('.fa')

    if (icon.classList.contains('fa-bars')) {
      icon.classList.remove('fa-bars')
      icon.classList.add('fa-times')
    } else if (icon.classList.contains('fa-times')) {
      icon.classList.remove('fa-times')
      icon.classList.add('fa-bars')
    }
  }

  function toggleNavigation() {
    let navigation = element.querySelector('.navigation--viewport')

    let inAnimation = 'fade-in'
    let outAnimation = 'fade-out'
    if (window.matchMedia("(max-width: 768px)").matches) {
      inAnimation = 'move-from-right'
      outAnimation = 'move-to-right'
    }
    if (navigation.classList.contains('visible')) {
      up.animate(navigation, outAnimation).then(() => {
        navigation.classList.remove('visible')
      })
    } else {
      navigation.classList.add('visible')
      up.animate(navigation, inAnimation)
    }
  }

  init()

})
